import Http from "../services/Providers/Http";

const ENDPOINTS = {
  GET_PRODUCTS: "/api/staff/getProducts",
  GET_PAYMETHODS: "/api/staff/getPaymethods",
  CREATE_SETTINGGROUP: "/api/staff/createSettingGroup",
  UPDATE_SETTINGGROUP: "/api/staff/updateSettingGroup",
  REMOVE_SETTINGGROUP: "/api/staff/removeSettingGroup",
  ACTIVE_SETTINGGROUP: "/api/staff/activeSettingGroup",
  GET_STATS: "/api/staff/stats",
};

export default {
  getMyProducts: (payload, params) => {
    return Http.get(ENDPOINTS.GET_PRODUCTS, params, null, payload);
  },
  getPaymethods: (payload, params) => {
    return Http.get(ENDPOINTS.GET_PAYMETHODS, params, null, payload);
  },
  createSettingGroup: (body, payload, params) => {
    return Http.post(ENDPOINTS.CREATE_SETTINGGROUP, body, params, null, payload);
  },
  updateSettingGroup: (body, payload, params) => {
    return Http.post(ENDPOINTS.UPDATE_SETTINGGROUP, body, params, null, payload);
  },
  removeSettingGroup: (body, payload, params) => {
    return Http.post(ENDPOINTS.REMOVE_SETTINGGROUP, body, params, null, payload);
  },
  activeSettingGroup: (body, payload, params) => {
    return Http.post(ENDPOINTS.ACTIVE_SETTINGGROUP, body, params, null, payload);
  },
  getStats: (payload, params) => {
    return Http.get(ENDPOINTS.GET_STATS, params, null, payload);
  },
}; 